import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { DataLake } from "@graylog/enterprise-api";
import { Modal } from "components/bootstrap";
import { ModalSubmit } from "components/common";
import RetrievalHelp from "data-lake/RetrievalHelp";
import UserNotification from "util/UserNotification";
import useSelectableLogViewMessages from "logview/components/contexts/useSelectableLogViewMessages";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import useRetrieval from "data-lake/preview/hooks/useRetrieval";
import useSelectedMessageEntities from "views/hooks/useSelectedMessageEntities";
const BulkRetrievalModal = ({ onCancel, retrievalPayload }) => {
  var _a;
  const { t } = useTranslation("enterprise_data_lake");
  const { isEntitySelected, selectedEntities } = useSelectedMessageEntities();
  const { selectableLogViewMessages } = useSelectableLogViewMessages();
  const { selectedDataLake } = useSelectedDataLake();
  const { bulkRetrievePayload } = useRetrieval();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const onSubmit = useCallback(() => {
    const selectedMessages = selectableLogViewMessages.filter(({ id, index }) => isEntitySelected(index, id)).map(({ id, timestamp }) => ({ id, timestamp }));
    setIsSubmitting(true);
    DataLake.retrieveMultipleMessages(bulkRetrievePayload(selectedMessages, selectedDataLake.id, retrievalPayload)).then(() => {
      UserNotification.success(t("bulk_retrieval.success_notification"), t("bulk_retrieval.success_title"));
      onCancel();
    }).catch((error) => {
      UserNotification.error(t("bulk_retrieval.error_notification", { error: `${error}` }));
    }).finally(() => {
      setIsSubmitting(false);
    });
  }, [
    selectableLogViewMessages,
    bulkRetrievePayload,
    selectedDataLake.id,
    retrievalPayload,
    isEntitySelected,
    onCancel,
    t
  ]);
  return /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: onCancel }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, t("bulk_retrieval.title"))), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement("p", null, t("bulk_retrieval.retrieve_count", { count: (_a = selectedEntities == null ? void 0 : selectedEntities.length) != null ? _a : 0 })), /* @__PURE__ */ React.createElement(RetrievalHelp, null)), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      onCancel,
      submitButtonText: t("bulk_retrieval.submit_button"),
      isSubmitting,
      submitLoadingText: t("bulk_retrieval.submit_loading"),
      onSubmit,
      isAsyncSubmit: true
    }
  )));
};
export default BulkRetrievalModal;
